import { Injectable, signal, computed } from '@angular/core';
import { defer, finalize, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private _pending = signal(0);
  readonly isLoading = computed(() => this._pending() > 0);

  /** Marca inicio y devuelve un stop() seguro (idempotente). */
  start(): () => void {
    this._pending.update(n => n + 1);
    let done = false;
    return () => {
      if (!done) {
        done = true;
        this._pending.update(n => Math.max(0, n - 1));
      }
    };
  }

  /** Azúcar: envuelve una promesa/función async. */
  async run<T>(task: Promise<T> | (() => Promise<T>)): Promise<T> {
    const stop = this.start();
    try {
      const p = typeof task === 'function' ? (task as any)() : task;
      return await p;
    } finally {
      stop();
    }
  }

  /**
   * Versión para Observables (HTTP, etc).
   * Usa finalize() para cortar el spinner al completar/errar.
   */
  run$<T>(source: Observable<T> | (() => Observable<T>)): Observable<T> {
    return defer(() => {
      const stop = this.start();
      const obs = typeof source === 'function' ? (source as () => Observable<T>)() : source;
      return obs.pipe(finalize(stop));
    });
  }
}
